import { createAction, props } from '@ngrx/store';

export const setIntermediaryRelatedAction = createAction(
  '[INTERMEDIARY] Set INTERMEDIARY',
  props<{ intermediaryRelated: boolean }>()
);